module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_04-5eb536993a15d0c7c08193232ad6b1ec.png";